import { IColumn } from "../../../models";

export const patient: IColumn = {
  A: {
    key: "firstName",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "First Name",
  },
  B: {
    key: "lastName",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Last Name",
  },
  C: {
    key: "gender",
    valueType: "string",
    validationTypes: ["empty", "gender"],
    columnText: "Gender",
  },
  D: {
    key: "dateOfBirth",
    valueType: "date",
    validationTypes: ["empty", "date"],
    columnText: "Date of Birth (mm/dd/yyyy)",
  },
  E: {
    key: "phoneNumber",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Phone Number",
  },
  F: {
    key: "email",
    valueType: "string",
    validationTypes: ["empty", "email"],
    columnText: "Email",
  },
  G: {
    key: "insuranceTypeId",
    valueType: "string",
    validationTypes: ["empty", "insurance_id"],
    columnText: "Insurance Type Id",
  },
  H: {
    key: "address",
    valueType: "string",
    validationTypes: ["empty", "address"],
    columnText: "Address",
  },
  I: {
    key: "apartmentNumber",
    valueType: "string",
    validationTypes: [],
    columnText: "Apartment",
  },
  J: {
    key: "emergencyContactPersonName",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Emergency Contact Person Name",
  },
  K: {
    key: "emergencyContactPersonPhone",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Emergency Contact Person Phone",
  },
  L: {
    key: "insuranceId",
    valueType: "string",
    validationTypes: ["empty", "unique"],
    columnText: "Member/Insurance Id Number (unique)",
  },
  M: {
    key: "medicalCode",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Medical Code",
  },
  N: {
    key: "serviceAuthorizationStartDate",
    valueType: "date",
    validationTypes: ["empty", "date"],
    columnText: "Service Authorization Start Date (mm/dd/yyyy)",
  },
  O: {
    key: "serviceAuthorizationEndDate",
    valueType: "date",
    validationTypes: ["empty", "date"],
    columnText: "Service Authorization End Date (mm/dd/yyyy)",
  },
  P: {
    key: "totalUnit",
    valueType: "number",
    validationTypes: ["empty", "number"],
    columnText: "Total Unit (1 unit = 15 minutes)",
  },
  Q: {
    key: "perUnitCost",
    valueType: "number",
    validationTypes: ["empty", "number"],
    columnText: "Per unit cost",
  },
  R: {
    key: "caseWorker",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Case Worker",
  },
  S: {
    key: "caseWorkerPhoneNumber",
    valueType: "string",
    validationTypes: [],
    columnText: "Case Worker Phone Number",
  },
  T: {
    key: "caseWorkerEmail",
    valueType: "string",
    validationTypes: ["empty", "email"],
    columnText: "Case Worker Email",
  },
  U: {
    key: "caseManager",
    valueType: "string",
    validationTypes: [],
    columnText: "Case Manager",
  },
  V: {
    key: "caseManagerPhoneNumber",
    valueType: "string",
    validationTypes: [],
    columnText: "Case Manager Phone Number",
  },
  W: {
    key: "caseManagerEmail",
    valueType: "string",
    validationTypes: ["email"],
    columnText: "Case Manager Email",
  },
  X: {
    key: "isTransportAvailable",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Transport Available? (Yes/No)",
  },
  Y: {
    key: "isSignatureRequired",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Signature Required? (Yes/No)",
  },
  Z: {
    key: "specialInstructions",
    valueType: "string",
    validationTypes: [],
    columnText: "Special Instructions",
  },
};

export const patientRequiredColumn = Object.values(patient).filter((column) =>
  column.validationTypes.includes("empty")
);
